import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { v4 } from "uuid";
import { useTheme } from "@emotion/react";
import { Button, Typography } from "@mui/material";
import { useStyles } from "../../../theme/style";
import CheckIcon from "@mui/icons-material/Check";
import WestIcon from "@mui/icons-material/West";
import Modal from "../../../components/Modal/Modal";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import { useDispatch } from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MUITextField from "@mui/material/TextField";
import {
  approveRejectRapidApplication,
  rapidSaveAsDraft,
  submitRapidApplicationRequest,
} from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { set } from "lodash";
import Checkbox from "@mui/material/Checkbox";
import { getCostFromJson, getStatusButton } from "../../../utils/utils";
import APP_CONSTANTS from "../../../utils/config";
import Loader from "../../../components/Loader";
import { TableFooter } from "@material-ui/core";

const CustomStyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    overflowY: "hidden",
    backgroundColor: "#fff",
  },
  "& .MuiDialog-paperWidthSm": {
    height: "550px !important",
    width: "850px !important",
    maxWidth: "990px !important",
    maxHeight: "666px !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "0",
    borderRadius: theme.size[10],
  },
}));

const columns = [
  { id: "module", label: "Module", minWidth: 170, align: "left" },
  { id: "component", label: "Component", minWidth: 100, align: "left" },
  {
    id: "dev",
    label: "DEV",
    minWidth: 100,
    align: "center",
  },
  {
    id: "uat",
    label: "UAT",
    minWidth: 100,
    align: "center",
  },
  {
    id: "prod",
    label: "PROD",
    minWidth: 100,
    align: "center",
  },
  {
    id: "dev",
    label: "DEV",
    minWidth: 100,
    align: "center",
  },
  {
    id: "uat",
    label: "UAT",
    minWidth: 100,
    align: "center",
  },
  {
    id: "prod",
    label: "PROD",
    minWidth: 100,
    align: "center",
  },
];

const finalApprovalcolumn = [
  // { id: "module", label: "Total", minWidth: 170, align: "left" },
  {
    id: "dev",
    label: "DEV",
    minWidth: 50,
    align: "left",
  },
  {
    id: "uat",
    label: "UAT",
    minWidth: 50,
    align: "left",
  },
  {
    id: "prod",
    label: "PROD",
    minWidth: 50,
    align: "left",
  },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.table.background,
    color: theme.palette.table.heading,
    fontSize: theme.size[14],
    fontWeight: theme.fontWeight[600],
  },
  [`&.${tableCellClasses.body}`]: {
    backgroundColor: theme.palette.table.background,
    color: theme.palette.secondary.main,
    fontSize: theme.size[14],
    fontWeight: theme.fontWeight[600],
  },
  ["&.footer-cell"]: {
    color: theme.palette.secondary.main,
    fontWeight: theme.fontWeight[600],
    backgroundColor: theme.palette.table.background,
  },
}));

const ApprovalPopup = ({
  localCost,
  closePopup,
  showApproveRejectPopup,
  theme,
  approvalStatus,
  comments,
  setComments,
  handleApproveReject,
  sendNotification,
  setSendNotification,
  classes,
  loading = false,
}) => {
  return (
    <>
      <CustomStyledDialog
        onClose={closePopup}
        open={showApproveRejectPopup}
        // open={true}
      >
        <div
          style={{
            height: "100%",
            margin: "15px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              fontSize: theme.size[20],
              fontWeight: theme.fontWeight[600],
              height: "47px",
            }}
          >
            {approvalStatus === "approved" ? "Approve" : "Reject"} Application
          </div>

          {localCost.length !== 0 && (
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: "450px" }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center" colSpan={4}>
                        Total Cost
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell align="center"></StyledTableCell>
                      {finalApprovalcolumn.map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{ top: 57, minWidth: column.minWidth }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow hover role="checkbox" tabIndex={-1} key={1}>
                      <TableCell align={"left"}>Monthly</TableCell>
                      <TableCell align={"left"}>
                        {localCost[localCost.length - 1]?.monthlyCost.dev || 0}
                      </TableCell>
                      <TableCell align={"left"}>
                        {localCost[localCost.length - 1]?.monthlyCost.uat || 0}
                      </TableCell>
                      <TableCell align={"left"}>
                        {localCost[localCost.length - 1]?.monthlyCost.prod || 0}
                      </TableCell>
                    </TableRow>
                    <TableRow hover role="checkbox" tabIndex={-1} key={2}>
                      <TableCell align={"left"}>Annually</TableCell>
                      <TableCell align={"left"}>
                        {localCost[localCost.length - 1].annualCost.dev || 0}
                      </TableCell>
                      <TableCell align={"left"}>
                        {localCost[localCost.length - 1].annualCost.uat || 0}
                      </TableCell>
                      <TableCell align={"left"}>
                        {localCost[localCost.length - 1].annualCost.prod || 0}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}

          <div style={{ marginTop: theme.size[12], display: "flex" }}>
            <Typography
              sx={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
              }}
            >
              Add Comments
            </Typography>
            {approvalStatus === "rejected" && (
              <>
                <span
                  style={{
                    color: theme.palette.error.main,
                    marginLeft: theme.size[4],
                  }}
                >
                  *
                </span>
                <span
                  style={{
                    color: theme.palette.secondary.main,
                    marginLeft: theme.size[4],
                    fontSize: theme.size[14],
                  }}
                >
                  (Adding comments is mandatory to reject the request)
                </span>
              </>
            )}
          </div>
          <div style={{ height: "100px" }}>
            <MUITextField
              multiline
              value={comments}
              placeholder={"Add your comment here"}
              disabled={false}
              onChange={(e) => {
                setComments(e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  flex: 1,
                  padding: `${theme.size[8.5]} ${theme.size[13]}`,
                  fontSize: theme.size[13],
                  color: theme.palette.text.secondary,
                  color: theme.palette.form.text,
                  backgroundColor: theme.palette.form.fieldBackground,
                },
                "& .MuiOutlinedInput-input": {
                  height: "100% !important",
                },
                "&.MuiTextField-root": {
                  backgroundColor: theme.palette.grey[4],
                  width: "100%",
                  height: "100%",
                  borderRadius: theme.size[4],
                  fontFamily: theme.typography["fontFamily"],
                  "&:hover": {
                    borderColor: "transparent",
                  },
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent !important",
                },
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: theme.size[4],
            }}
          >
            <Checkbox
              checked={sendNotification}
              onChange={() => {
                setSendNotification(!sendNotification);
              }}
              sx={{
                padding: "0",
                color: theme.palette.secondary.main,
                "&.Mui-checked": {
                  color: theme.palette.secondary.main,
                },
                "& .MuiSvgIcon-root": {
                  fontSize: theme.size[18], // Adjust the size of the icon inside the checkbox
                },
              }}
            />
            <Typography
              sx={{
                marginLeft: theme.size[4],
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
              }}
            >
              Send Notification
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: theme.size[24],
            }}
          >
            <Button
              disableRipple
              className={classes.outlinedButton}
              onClick={() => closePopup()}
              style={{
                fontWeight: theme.fontWeight[500],
                marginRight: theme.size[12],
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CloseIcon
                  sx={{
                    fontSize: theme.size[18],
                    marginRight: theme.size[4],
                  }}
                />
                <span>Cancel</span>
              </div>
            </Button>
            <Button
              disableRipple
              className={classes.filledButton}
              onClick={() => {
                handleApproveReject();
              }}
              disabled={
                loading || (approvalStatus === "rejected" && comments === "")
              }
              style={{
                fontWeight: theme.fontWeight[500],
              }}
            >
              {approvalStatus === "approved" ? "Approve" : "Reject"}
            </Button>
          </div>
        </div>

        {/* Close Icon Top-Right */}
        <IconButton
          type="button"
          sx={{
            borderRadius: theme.size[6],
            width: theme.size[35],
            height: theme.size[35],
            position: "absolute",
            top: "6px",
            right: "10px",
          }}
          aria-label="expand collapse menu"
          onClick={closePopup}
        >
          <CloseOutlinedIcon />
        </IconButton>
      </CustomStyledDialog>
    </>
  );
};

function CostApprovalPage({
  isRegistering = false,
  register_id,
  status,
  is_admin = false,
  handleBack = () => {},
}) {
  const infraDataJson = useSelector((state) => state.data.rapidData?.infraJson);
  const detailsJson = useSelector((state) => state.data.rapidData?.detailsJson);
  const aiModelJson = useSelector((state) => state.data.rapidData?.aiModelJson);
  const acceleratorLibraryJson = useSelector((state) => state.data.rapidData?.accLibraryJson);
  const theme = useTheme();
  const [localCost, setLocalCost] = React.useState([]);
  const classes = useStyles(theme);
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [showPopup, setShowPopup] = React.useState(false);
  const [showApproveRejectPopup, setShowApproveRejectPopup] =
    React.useState(false);

  const [sendNotification, setSendNotification] = React.useState(false);
  const [approvalStatus, setApprovalStatus] = React.useState("");

  const [comments, setComments] = React.useState("");

  const getDevEnvironment = (infraJson) => {
    const component = infraJson[0]?.components[1];
    return {
      dev: component?.properties[0].is_checked || false,
      uat: component?.properties[1].is_checked || false,
      prod: component?.properties[2].is_checked || false,
    };
  };
  React.useEffect(() => {
    const enviromant = getDevEnvironment(infraDataJson);
    const data = getCostFromJson(
      infraDataJson,
      enviromant?.dev,
      enviromant?.uat,
      enviromant?.prod
    );
    setLocalCost(data);
  }, []);

  const navigate = useNavigate();

  const submitApplicationRequest = async () => {
    const payload = {
      infra_details: infraDataJson,
      details: detailsJson,
      cost: localCost,
      choose_ai_model: aiModelJson,
      accelerator_libraries: acceleratorLibraryJson,
      status: "submit_for_approval",
      request_id: register_id || "",
    };
    try {
      const resp = await submitRapidApplicationRequest({
        payload: payload,
      });

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        navigate("/rapid");
        dispatch(
          updateAlertInfo({
            message: "Application has been submitted for approval",
            open: true,
            severity: "success",
          })
        );
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
      }
    } catch (err) {
      console.error("Error", err);
    }
    setLoading(false);
  };

  const handleSaveAsDraft = async () => {
    const payload = {
      infra_details: infraDataJson,
      details: detailsJson,
      status: status || "",
      request_id: register_id || "",
    };
    try {
      const resp = await rapidSaveAsDraft({
        payload: payload,
      });

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        navigate("/rapid");
        dispatch(
          updateAlertInfo({
            message: "Application is saved as draft",
            open: true,
            severity: "success",
          })
        );
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
      }
    } catch (err) {
      console.error("Error", err);
    }
    setLoading(false);
  };

  const handlePopupConfirm = async () => {
    setLoading(true);
    setShowPopup(false);
    await submitApplicationRequest();
  };

  const copyToClipboard = ({ register_id }) => {
    navigator.clipboard
      .writeText(register_id)
      .then(() => {
        dispatch(
          updateAlertInfo({
            message: "Copied",
            open: true,
            severity: "success",
          })
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const closePopup = () => {
    setShowApproveRejectPopup(false);
  };
  const handleApproveReject = async () => {
    setLoading(true);
    const payload = {
      request_id: register_id,
      status: approvalStatus === "approved" ? "approve" : "reject",
      comments: comments,
      send_notification: sendNotification,
    };
    try {
      const resp = await approveRejectRapidApplication({
        payload: payload,
      });

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        dispatch(
          updateAlertInfo({
            message: "Application has been " + approvalStatus,
            open: true,
            severity: "success",
          })
        );
        navigate("/rapid");
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
      }
    } catch (err) {
      console.error("Error", err);
    }
    setLoading(false);
  };

  return (
    <>
      {(!isRegistering ||
        status ===
          APP_CONSTANTS.RAPID_STATUS.TECHNICAL_OWNER_RESPONSE_PENDING) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: theme.size[12],
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
              }}
            >
              Request ID: {register_id}
            </Typography>
            <ContentCopyIcon
              sx={{
                marginLeft: theme.size[8],
                fontSize: theme.size[18],
                color: theme.palette.secondary.main,
                cursor: "pointer",
              }}
              onClick={copyToClipboard}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                marginRight: theme.size[4],
                fontWeight: theme.fontWeight[500],
                fontSize: theme.size[14],
              }}
            >
              Status:{" "}
            </span>
            <div
              style={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
              }}
            >
              {getStatusButton(status)}
            </div>
          </div>
        </div>
      )}
      {localCost.length !== 0 && (
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer
            sx={{ maxHeight: "calc(100vh - 400px)", overflow: "auto" }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center" colSpan={2}></StyledTableCell>
                  <StyledTableCell align="center" colSpan={3}>
                    Monthly Cost
                  </StyledTableCell>
                  <StyledTableCell align="center" colSpan={3}>
                    Annual Cost
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ top: 57, minWidth: column.minWidth }}
                    >
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {localCost.slice(0, -1).map((row) => {
                  const { module, component, monthlyCost, annualCost } = row;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.code}
                    >
                      <TableCell align={columns[0].align}>{module}</TableCell>
                      <TableCell align={columns[1].align}>
                        {component}
                      </TableCell>
                      <TableCell align={columns[2].align}>
                        {monthlyCost.dev !== "" ? `$ ${monthlyCost.dev}` : ""}
                      </TableCell>
                      <TableCell align={columns[3].align}>
                        {monthlyCost.uat !== "" ? `$ ${monthlyCost.uat}` : ""}
                      </TableCell>
                      <TableCell align={columns[4].align}>
                        {monthlyCost.prod !== "" ? `$ ${monthlyCost.prod}` : ""}
                      </TableCell>
                      <TableCell align={columns[5].align}>
                        {annualCost.dev !== "" ? `$ ${annualCost.dev}` : ""}
                      </TableCell>
                      <TableCell align={columns[6].align}>
                        {annualCost.uat !== "" ? `$ ${annualCost.uat}` : ""}
                      </TableCell>
                      <TableCell align={columns[7].align}>
                        {annualCost.prod !== "" ? `$ ${annualCost.prod}` : ""}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
              <TableFooter>
                <TableRow
                  sx={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "white",
                    boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <StyledTableCell
                    align={columns[0].align}
                    className="footer-cell"
                    style={{ minWidth: columns[0].minWidth, left: 0 }}
                  >
                    Total
                  </StyledTableCell>
                  <StyledTableCell
                    align={columns[1].align}
                    className="footer-cell"
                    style={{ minWidth: columns[1].minWidth, left: 0 }}
                  ></StyledTableCell>
                  <StyledTableCell
                    align={columns[2].align}
                    className="footer-cell"
                    style={{ minWidth: columns[2].minWidth, left: 0 }}
                  >
                    {localCost[localCost.length - 1]?.monthlyCost.dev !== ""
                      ? `$ ${localCost[localCost.length - 1].monthlyCost.dev}`
                      : ""}
                  </StyledTableCell>
                  <StyledTableCell
                    align={columns[3].align}
                    className="footer-cell"
                    style={{ minWidth: columns[3].align, left: 0 }}
                  >
                    {localCost[localCost.length - 1]?.monthlyCost.uat !== ""
                      ? `$ ${localCost[localCost.length - 1].monthlyCost.uat}`
                      : ""}
                  </StyledTableCell>
                  <StyledTableCell
                    align={columns[4].align}
                    className="footer-cell"
                    style={{ minWidth: columns[4].minWidth, left: 0 }}
                  >
                    {localCost[localCost.length - 1]?.monthlyCost.prod !== ""
                      ? `$ ${localCost[localCost.length - 1].monthlyCost.prod}`
                      : ""}
                  </StyledTableCell>
                  <StyledTableCell
                    align={columns[5].align}
                    className="footer-cell"
                    style={{ minWidth: columns[5].minWidth, left: 0 }}
                  >
                    {localCost[localCost.length - 1]?.annualCost.dev !== ""
                      ? `$ ${localCost[localCost.length - 1].annualCost.dev}`
                      : ""}
                  </StyledTableCell>
                  <StyledTableCell
                    align={columns[6].align}
                    className="footer-cell"
                    style={{ minWidth: columns[6].minWidth, left: 0 }}
                  >
                    {localCost[localCost.length - 1]?.annualCost.uat !== ""
                      ? `$ ${localCost[localCost.length - 1].annualCost.uat}`
                      : ""}
                  </StyledTableCell>
                  <StyledTableCell
                    align={columns[7].align}
                    className="footer-cell"
                    style={{ minWidth: columns[7].minWidth, left: 0 }}
                  >
                    {localCost[localCost.length - 1]?.annualCost.prod !== ""
                      ? `$ ${localCost[localCost.length - 1].annualCost.prod}`
                      : ""}
                  </StyledTableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Paper>
      )}

      {/* Footer */}
      {isRegistering ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            bottom: -10,
            position: "absolute",
            width: "100%",
          }}
        >
          <div>
            <div>
              <Button
                disableRipple
                className={classes.outlinedButton}
                onClick={() => handleBack()}
                style={{
                  fontWeight: theme.fontWeight[500],
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <WestIcon
                    sx={{
                      fontSize: theme.size[18],
                      marginRight: theme.size[4],
                    }}
                  />
                  <span>Back</span>
                </div>
              </Button>
              <Button
                disableRipple
                className={classes.outlinedButton}
                onClick={() => handleSaveAsDraft()}
                style={{
                  fontWeight: theme.fontWeight[500],
                  background: theme.palette.saveAsDraftButton.background,
                  color: theme.palette.saveAsDraftButton.text,
                  border: `1px solid ${theme.palette.saveAsDraftButton.background}`,
                  marginLeft: theme.size[8],
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span>Save as Draft</span>
                </div>
              </Button>
            </div>
            <div
              style={{
                fontSize: theme.size[12],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.rapidInfra.text,
                paddingTop: theme.size[4],
              }}
            >
              Project Type and Components
            </div>
          </div>

          <Button
            disableRipple
            className={classes.filledButton}
            disabled={loading}
            onClick={() => {
              setShowPopup(true);
            }}
            style={{
              fontWeight: theme.fontWeight[500],
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CheckIcon
                sx={{
                  fontSize: theme.size[18],
                  marginRight: theme.size[4],
                }}
              />
              <span>Submit for Approval</span>
            </div>
          </Button>
        </div>
      ) : is_admin &&
        status === APP_CONSTANTS.RAPID_STATUS.PENDING_INFORMATION ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "absolute",
            bottom: 10,
            width: "100%",
          }}
        >
          <Button
            disableRipple
            className={classes.outlinedButton}
            onClick={() => {
              setApprovalStatus("rejected");
              setShowApproveRejectPopup(true);
            }}
            style={{
              fontWeight: theme.fontWeight[500],
              marginRight: theme.size[12],
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CloseIcon
                sx={{
                  fontSize: theme.size[18],
                  marginRight: theme.size[4],
                }}
              />
              <span>Reject</span>
            </div>
          </Button>
          <Button
            disableRipple
            className={classes.filledButton}
            onClick={() => {
              setApprovalStatus("approved");
              setShowApproveRejectPopup(true);
            }}
            style={{
              fontWeight: theme.fontWeight[500],
              backgroundColor: "#50B428",
              borderColor: "#50B428",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CheckIcon
                sx={{
                  fontSize: theme.size[18],
                  marginRight: theme.size[4],
                }}
              />
              <span>Approve</span>
            </div>
          </Button>
        </div>
      ) : null}

      {/* Modal */}
      {showPopup && (
        <Modal
          headerMessage="Are you sure you want to Submit the Application?"
          cancelButtonText="Cancel"
          submitButtonText="Submit"
          onCancel={() => setShowPopup(false)}
          handleSubmit={handlePopupConfirm}
        />
      )}

      <ApprovalPopup
        localCost={localCost}
        closePopup={closePopup}
        showApproveRejectPopup={showApproveRejectPopup}
        theme={theme}
        approvalStatus={approvalStatus}
        comments={comments}
        setComments={setComments}
        handleApproveReject={handleApproveReject}
        sendNotification={sendNotification}
        setSendNotification={setSendNotification}
        classes={classes}
        loading={loading}
      />

      {loading && (
        <div
          style={{
            position: "fixed",
            margin: "50px 0 0 63px",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <Loader
            showLoadingImage={false}
            circleStyle={{
              color: "rgba(0, 0, 0, 0.1)",
            }}
            circleSize={"40px"}
          />
        </div>
      )}
    </>
  );
}

export default CostApprovalPage;
